import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import {
  EMPTY_TO_MANY,
  EMPTY_TO_ONE,
  linkageFromResource,
} from '@opallabs/json-api'
import { richTextDocumentResourceFactory } from './rich_text_document'
import { userResourceFactory } from './user'
import { workspaceResourceFactory } from './workspace'

type BlockResourceV3 = OpalApiComponent<'V3', 'block'>

const workspaceAccess = (workspace: OpalApiComponent<'V3', 'workspace'>) => ({
  ...linkageFromResource(workspace).data,
  meta: {
    inherits_membership: true,
    title: workspace.attributes.name,
    count: 1,
  },
})

export const blockResourceFactory: Factory<BlockResourceV3> =
  Factory.define<BlockResourceV3>(({ sequence }) => {
    return {
      id: uuidV4(),
      type: 'block',
      attributes: {
        color: null,
        created_at: new Date().toISOString(),
        description: null,
        duration: null,
        row_index: 0,
        start_at: null,
        title: `Mock Block ${sequence}`,
        updated_at: new Date().toISOString(),
        y_scale: 0,
        is_template: false,
        browsable: false,
        template_name: null,
        template_description: null,
        is_workspace_wide_template: false,
      },
      relationships: {
        asset: EMPTY_TO_ONE,
        boards: EMPTY_TO_MANY,
        category_type: EMPTY_TO_ONE,
        category: EMPTY_TO_ONE,
        child_view: EMPTY_TO_ONE,
        creator: linkageFromResource(userResourceFactory.build()),
        custom_field_values: EMPTY_TO_MANY,
        inherited_custom_field_values: EMPTY_TO_MANY,
        owner: linkageFromResource(userResourceFactory.build()),
        paired_moment: EMPTY_TO_ONE,
        rich_text_document: linkageFromResource(
          richTextDocumentResourceFactory.build()
        ),
        view: EMPTY_TO_ONE,
        workspace: linkageFromResource(workspaceResourceFactory.build()),
      },
      meta: {
        access: {
          users: [linkageFromResource(userResourceFactory.build()).data],
          groups: [],
          resources: [workspaceAccess(workspaceResourceFactory.build())],
        },
        custom_fields: [],
        effective_category_type: null,
      },
    } satisfies BlockResourceV3
  })
